var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bank-account",class:{
    selected: _vm.selectedAccount === _vm.val.id,
    notselected: _vm.selectedAccount && _vm.selectedAccount !== _vm.val.id
  }},[_c('div',{staticClass:"holder-name"},[_vm._v(_vm._s(_vm.val.account_holder_name))]),_c('div',{staticClass:"bank-name"},[_vm._v(_vm._s(_vm.val.bank_name))]),_c('div',{staticClass:"status"},[_vm._v(_vm._s(_vm._f("capitalize")(_vm.val.status)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }